import React from 'react'
import { SelectInput } from 'react-admin'

const TypeSelect = props => {
  const choises = [
    { id: 'transaction', name: 'Transaction' },
    { id: 'checkout', name: 'Checkout' },
    { id: 'card_validation', name: 'Card Validation' }
  ]

  return (
    <SelectInput {...props} choices={choises}/>
  )
}

export default TypeSelect
